import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const SnackbarsWrapper = ({ position, children, theme }) => (
    <div
        className={ classnames({
            [theme.snackbarWrapper]: true,
            [theme.positionTop]: position.vertical === 'top',
            [theme.positionCenter]: position.horizontal === 'center',
            [theme.positionRight]: position.horizontal === 'right',
        }) }
    >
        {children}
    </div>
);

SnackbarsWrapper.propTypes = {
    position: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string,
    }),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    theme: PropTypes.shape({}),
};

export default SnackbarsWrapper;
